var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pct-toolbar" },
    [
      _c("a-input-search", {
        staticClass: "pct-search",
        attrs: { placeholder: _vm.searchPlaceholder, size: "large" },
        model: {
          value: _vm.localSearch,
          callback: function ($$v) {
            _vm.localSearch = $$v
          },
          expression: "localSearch",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pct-actions" },
        [
          _vm.canCreateTitle
            ? _c(
                "SupsisButton",
                {
                  attrs: { primary: "", classNames: "pct-btn" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("create-title")
                    },
                  },
                },
                [
                  _c("md-icon", { staticStyle: { color: "white" } }, [
                    _vm._v("add"),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.titleButtonText) +
                      "\n        "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { primary: "", classNames: "pct-btn" },
              on: {
                click: function ($event) {
                  return _vm.$emit("create-content")
                },
              },
            },
            [
              _c("md-icon", { staticStyle: { color: "white" } }, [
                _vm._v("add"),
              ]),
              _vm._v(
                "\n            " + _vm._s(_vm.contentButtonText) + "\n        "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }